import {BaseService} from "./base";

class OnlineService extends BaseService {
  constructor() {
    super();
  }

  /**
   * 网络诊间视频回放
   * @param id
   * @returns {Promise<void>}
   */
  async recordList(id) {
    const {list = [], code} = await this.$http('smarthos.online.outpatient.video.record.list', {id})
    return code === '0' ? list : []
  }

  /**
   * 查询处方
   * @param id
   * @returns {Promise<*[]>}
   */
  async findPrescription(option) {
    return await this.$http('smarthos.outside.hospital.recipe.order.list', option)
  }
  /**
   * 查询处方-pdf处方签名
   * @param id
   * @returns {Promise<*[]>}
   */
  async findPrescriptionPDFSign(option) {
    return await this.$http('smarthos.outside.hospital.recipe.order.sign.generate.pdf', option)
  }


}

export const onlineService = new OnlineService();
